import { render, staticRenderFns } from "./f0x-photo.vue?vue&type=template&id=9abbbe1c&scoped=true&"
import script from "./f0x-photo.vue?vue&type=script&lang=js&"
export * from "./f0x-photo.vue?vue&type=script&lang=js&"
import style0 from "./f0x-photo.vue?vue&type=style&index=0&id=9abbbe1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../@vue-modules/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9abbbe1c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../@vue-modules/vuetify/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardTitle,VDialog,VIcon,VSpacer})
